import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import {
    HRM1030_R01FileDto,
    HRM1030_R01HeaderDto,
    HRM1030_R01TrainingDto,
    defaultHRM1030_R01FileDto,
    defaultHRM1030_R01HeaderDto,
    defaultHRM1030_R01TrainingDto,
} from './Dto_HRM1030_R01';
import { HRM1030_R01GridType } from './Util_HRM1030_R01';

/** 사원·교육 검색 조건이다. */
export interface HRM1030_R01Filter {
    trainYear: string; // 교육년도 YYYY (시작일 기준)
    trainType: string; // 교육구분 (공통코드 TRAIN_TYPE)
    compCd: string; // 사업장
    orgCd: string; // 부서
    empSts: string; // 재직상태
    keyword: string; // 사원번호 또는 이름
    empNm: string; // 팝업에서 선택한 사원명
}
/** 신규 화면의 검색 기본 조건이다. 교육년도는 올해, 재직상태는 재직(10)으로 시작한다. */
export const defaultHRM1030_R01Filter: HRM1030_R01Filter = {
    trainYear: String(new Date().getFullYear()),
    trainType: '',
    compCd: '',
    orgCd: '',
    empSts: '10',
    keyword: '',
    empNm: '',
};

/** 교육훈련 등록 화면 상태와 변경 함수이다. */
interface Store_HRM1030_R01 {
    HRM1030_R01Filter: HRM1030_R01Filter; // 현재 입력 중인 검색 조건
    HRM1030_R01PastFilter: HRM1030_R01Filter; // 마지막으로 조회한 검색 조건
    setHRM1030_R01Filter: (value: Partial<HRM1030_R01Filter>) => void; // 검색 조건 일부 변경
    setHRM1030_R01PastFilter: (value: HRM1030_R01Filter) => void; // 마지막 조회 조건 저장
    activeGridType: HRM1030_R01GridType; // 마지막으로 작업한 하위 그리드
    setActiveGridType: (value: HRM1030_R01GridType) => void; // 마지막 작업 그리드 변경

    HRM1030_R01List: HRM1030_R01HeaderDto[]; // 사원 목록
    setHRM1030_R01List: (value: HRM1030_R01HeaderDto[]) => void; // 서버 사원 목록으로 교체
    selectedHRM1030_R01?: HRM1030_R01HeaderDto; // 현재 선택한 사원
    setSelectedHRM1030_R01: (value?: HRM1030_R01HeaderDto) => void; // 선택 사원 변경

    HRM1030_R01TrainingList: HRM1030_R01TrainingDto[]; // 편집 중인 교육 목록
    setHRM1030_R01TrainingList: (value: HRM1030_R01TrainingDto[]) => void; // 서버 교육 목록으로 교체하고 교육·첨부 편집 상태 초기화
    updateHRM1030_R01TrainingList: (valueIndex: number, value: HRM1030_R01TrainingDto) => void; // valueIndex가 같은 교육 행 교체
    insertHRM1030_R01TrainingList: (value: HRM1030_R01TrainingDto, afterValueIndex?: number) => void; // 교육 행 추가
    removeHRM1030_R01TrainingList: (valueIndex: number) => void; // 교육 행과 그 교육의 첨부 제거
    selectedHRM1030_R01TrainingList: string[]; // 선택한 교육 valueIndex 문자열 목록
    setSelectedHRM1030_R01TrainingList: (value: string[]) => void; // 교육 선택 목록 변경
    addSelectedHRM1030_R01TrainingList: (ids: string[]) => void; // 공통 행 선택 훅용: 선택을 전달값으로 교체(작업지시와 같은 방식)
    removeSelectedHRM1030_R01TrainingList: (ids?: string[]) => void; // 공통 행 선택 훅용: ids 선택 해제, 없으면 전체 해제
    deletedHRM1030_R01TrainingList: string[]; // D 표시한 교육 valueIndex 문자열 목록
    setDeletedHRM1030_R01TrainingList: (value: string[]) => void; // 교육 D 표시 목록 변경
    originalHRM1030_R01TrainingList: HRM1030_R01TrainingDto[]; // 수정 여부 비교용 서버 교육 목록
    setOriginalHRM1030_R01TrainingList: (value: HRM1030_R01TrainingDto[]) => void; // 비교용 교육 목록 저장
    selectedHRM1030_R01Training?: number; // 첨부 대상 교육 행의 valueIndex (마지막으로 클릭한 교육)
    setSelectedHRM1030_R01Training: (value?: number) => void; // 첨부 대상 교육 변경

    HRM1030_R01FileList: HRM1030_R01FileDto[]; // 불러온 교육들의 첨부 전체 (trainingValueIndex로 교육 구분)
    appendHRM1030_R01FileList: (value: HRM1030_R01FileDto[]) => void; // 서버 첨부 또는 신규 첨부를 목록 끝에 추가
    updateHRM1030_R01FileList: (valueIndex: number, value: HRM1030_R01FileDto) => void; // valueIndex가 같은 첨부 행 교체
    removeHRM1030_R01FileList: (valueIndex: number) => void; // valueIndex가 같은 첨부 행 제거
    selectedHRM1030_R01FileList: string[]; // 선택한 첨부 valueIndex 문자열 목록
    setSelectedHRM1030_R01FileList: (value: string[]) => void; // 첨부 선택 목록 변경
    addSelectedHRM1030_R01FileList: (ids: string[]) => void; // 공통 행 선택 훅용: 선택을 전달값으로 교체(작업지시와 같은 방식)
    removeSelectedHRM1030_R01FileList: (ids?: string[]) => void; // 공통 행 선택 훅용: ids 선택 해제, 없으면 전체 해제
    deletedHRM1030_R01FileList: string[]; // D 표시한 첨부 valueIndex 문자열 목록
    setDeletedHRM1030_R01FileList: (value: string[]) => void; // 첨부 D 표시 목록 변경
    originalHRM1030_R01FileList: HRM1030_R01FileDto[]; // 비고 수정 여부 비교용 서버 첨부 목록
    loadedHRM1030_R01FileTrainingList: string[]; // 첨부를 이미 불러온 교육 valueIndex 문자열 목록
    addLoadedHRM1030_R01FileTrainingList: (value: string) => void; // 첨부를 불러온 교육 기록

    columnState: ColumnState[] | null; // 사원 그리드 컬럼 배치. null이면 기본 배치
    trainingColumnState: ColumnState[] | null; // 교육 그리드 컬럼 배치
    fileColumnState: ColumnState[] | null; // 첨부 그리드 컬럼 배치
    setColumnState: (value: ColumnState[] | null) => void; // 사원 그리드 컬럼 배치 저장
    setTrainingColumnState: (value: ColumnState[] | null) => void; // 교육 그리드 컬럼 배치 저장
    setFileColumnState: (value: ColumnState[] | null) => void; // 첨부 그리드 컬럼 배치 저장
    scrollTop: number | null; // 사원 그리드 스크롤 위치. null이면 맨 위
    trainingScrollTop: number | null; // 교육 그리드 스크롤 위치
    fileScrollTop: number | null; // 첨부 그리드 스크롤 위치
    setScrollTop: (value: number | null) => void; // 사원 그리드 스크롤 위치 저장
    setTrainingScrollTop: (value: number | null) => void; // 교육 그리드 스크롤 위치 저장
    setFileScrollTop: (value: number | null) => void; // 첨부 그리드 스크롤 위치 저장
    allCount: number; // 검색 조건에 맞는 전체 사원 수
    setAllCount: (value: number) => void; // 전체 사원 수 저장
    initData: () => void; // 화면 전체 상태 초기화
}

/**
 * 서버 행에 화면 식별값과 기본 필드를 채운다(HRM1040과 같은 방식).
 * @param rows 서버에서 받은 행 목록
 * @param defaults 서버 행에 없는 필드를 채울 기본 행
 * @param startIndex 첫 행에 매길 valueIndex (기본 1)
 * @returns 순서대로 valueIndex·orderIndex를 매긴 행 목록
 */
const buildRows = <T extends { valueIndex: number; orderIndex: number; orderIndexSeq: number }>(
    rows: T[],
    defaults: T,
    startIndex = 1,
): T[] => rows.map((row, index) => ({
    ...defaults,
    ...row,
    valueIndex: startIndex + index,
    orderIndex: startIndex + index,
    orderIndexSeq: 0,
}));

/** 지정한 행 뒤에 새 행을 삽입하고 중복되지 않는 화면 식별값을 부여한다(HRM1040과 같은 방식). */
const insertRow = <T extends { valueIndex: number }>(rows: T[], value: T, afterValueIndex?: number): T[] => {
    const result = [...rows];
    const targetIndex = result.findIndex(row => row.valueIndex === afterValueIndex);
    // 삼항 연산자: 기준 행이 없으면 맨 끝, 있으면 기준 행 바로 뒤에 넣는다.
    const insertPosition = afterValueIndex === undefined || targetIndex < 0
        ? result.length
        : targetIndex + 1;
    const nextValueIndex = Math.max(0, ...result.map(row => row.valueIndex)) + 1;

    result.splice(insertPosition, 0, { ...value, valueIndex: nextValueIndex });
    return result;
};

/** 교육 목록을 바꿀 때 함께 비우는 교육·첨부 편집 상태이다. */
const emptyTrainingState = {
    selectedHRM1030_R01TrainingList: [],
    deletedHRM1030_R01TrainingList: [],
    selectedHRM1030_R01Training: undefined,
    HRM1030_R01FileList: [],
    selectedHRM1030_R01FileList: [],
    deletedHRM1030_R01FileList: [],
    originalHRM1030_R01FileList: [],
    loadedHRM1030_R01FileTrainingList: [],
};

/** 교육 이력 그리드의 시작일·종료일 공통 달력(GridCalendar) 상태이다. PRD2010_R01 작업지시와 같은 구성이다. */
export interface Store_HRM1030_R01_GridCalendarState {
    HRM1030_R01GridCalendarState: {
        pickerVisible: boolean; // true이면 달력을 표시한다
        pickerPosition: { top: number; left: number }; // 달력을 띄울 화면 좌표
        targetRowIndex: number | null; // 날짜를 고치는 교육 행의 표시 순서
        targetField: string | null; // 날짜를 고치는 컬럼 (startDt 또는 endDt)
        targetDate: Date | undefined; // 달력에 처음 표시할 날짜
    };
    setHRM1030_R01GridCalendarState: (state: Partial<Store_HRM1030_R01_GridCalendarState['HRM1030_R01GridCalendarState']>) => void; // 달력 상태 일부 변경
    initHRM1030_R01GridCalendarState: () => void; // 달력 상태 초기화
}

/** 달력 상태의 초기값이다. */
const defaultHRM1030_R01GridCalendarState: Store_HRM1030_R01_GridCalendarState['HRM1030_R01GridCalendarState'] = {
    pickerVisible: false,
    pickerPosition: { top: 0, left: 0 },
    targetRowIndex: null,
    targetField: null,
    targetDate: undefined,
};

/** 교육 이력 그리드의 공통 달력 상태를 보관하는 Zustand Hook이다(PRD2010_R01 `usePRD2010_R01Store_GridCalendar`와 같은 형태). */
export const useHRM1030_R01Store_GridCalendar = create<Store_HRM1030_R01_GridCalendarState>((set) => ({
    HRM1030_R01GridCalendarState: { ...defaultHRM1030_R01GridCalendarState },
    setHRM1030_R01GridCalendarState: newState => set(state => ({
        HRM1030_R01GridCalendarState: { ...state.HRM1030_R01GridCalendarState, ...newState },
    })),
    initHRM1030_R01GridCalendarState: () => set({ HRM1030_R01GridCalendarState: { ...defaultHRM1030_R01GridCalendarState } }),
}));

/** 교육훈련 등록 화면 전용 상태를 보관하는 Zustand Hook이다. */
export const useHRM1030_R01Store = create<Store_HRM1030_R01>((set) => ({
    HRM1030_R01Filter: { ...defaultHRM1030_R01Filter },
    HRM1030_R01PastFilter: { ...defaultHRM1030_R01Filter },
    setHRM1030_R01Filter: value => set(state => ({ HRM1030_R01Filter: { ...state.HRM1030_R01Filter, ...value } })),
    setHRM1030_R01PastFilter: value => set({ HRM1030_R01PastFilter: { ...value } }),
    activeGridType: 'training',
    setActiveGridType: value => set({ activeGridType: value }),

    HRM1030_R01List: [],
    setHRM1030_R01List: value => set({ HRM1030_R01List: buildRows(value, defaultHRM1030_R01HeaderDto) }),
    selectedHRM1030_R01: undefined,
    setSelectedHRM1030_R01: value => set({ selectedHRM1030_R01: value }),

    HRM1030_R01TrainingList: [],
    setHRM1030_R01TrainingList: value => set({
        HRM1030_R01TrainingList: buildRows(value, defaultHRM1030_R01TrainingDto),
        ...emptyTrainingState,
    }),
    updateHRM1030_R01TrainingList: (valueIndex, value) => set(state => ({
        HRM1030_R01TrainingList: state.HRM1030_R01TrainingList.map(row =>
            row.valueIndex === valueIndex ? value : row),
    })),
    insertHRM1030_R01TrainingList: (value, afterValueIndex) => set(state => ({
        HRM1030_R01TrainingList: insertRow(state.HRM1030_R01TrainingList, value, afterValueIndex),
    })),
    removeHRM1030_R01TrainingList: valueIndex => set(state => ({
        HRM1030_R01TrainingList: state.HRM1030_R01TrainingList.filter(row => row.valueIndex !== valueIndex),
        // 신규 교육을 지우면 그 교육에 붙인 신규 첨부도 함께 지운다.
        HRM1030_R01FileList: state.HRM1030_R01FileList.filter(row => row.trainingValueIndex !== valueIndex),
        // 삼항 연산자: 지운 교육이 첨부 대상이었으면 대상을 비운다.
        selectedHRM1030_R01Training: state.selectedHRM1030_R01Training === valueIndex ? undefined : state.selectedHRM1030_R01Training,
    })),
    selectedHRM1030_R01TrainingList: [],
    setSelectedHRM1030_R01TrainingList: value => set({ selectedHRM1030_R01TrainingList: value.map(String) }),
    // 공통 useRowSelectionHandler가 숫자 valueIndex를 넘겨도 문자열로 저장한다. 작업지시처럼 누적하지 않고 교체한다.
    addSelectedHRM1030_R01TrainingList: ids => set({ selectedHRM1030_R01TrainingList: ids.map(String) }),
    removeSelectedHRM1030_R01TrainingList: ids => set(state => ({
        // 삼항 연산자: ids가 있으면 그 식별값만 빼고, 없으면 전체 해제한다.
        selectedHRM1030_R01TrainingList: ids
            ? state.selectedHRM1030_R01TrainingList.filter(id => !ids.map(String).includes(id))
            : [],
    })),
    deletedHRM1030_R01TrainingList: [],
    setDeletedHRM1030_R01TrainingList: value => set({ deletedHRM1030_R01TrainingList: value.map(String) }),
    originalHRM1030_R01TrainingList: [],
    setOriginalHRM1030_R01TrainingList: value => set({
        originalHRM1030_R01TrainingList: buildRows(value, defaultHRM1030_R01TrainingDto),
    }),
    selectedHRM1030_R01Training: undefined,
    setSelectedHRM1030_R01Training: value => set({ selectedHRM1030_R01Training: value }),

    HRM1030_R01FileList: [],
    appendHRM1030_R01FileList: value => set(state => {
        // 첨부 valueIndex가 교육 사이에서도 겹치지 않게 현재 최대값 다음부터 매긴다.
        const startIndex = Math.max(0, ...state.HRM1030_R01FileList.map(row => row.valueIndex)) + 1;
        const rows = buildRows(value, defaultHRM1030_R01FileDto, startIndex);
        return {
            HRM1030_R01FileList: [...state.HRM1030_R01FileList, ...rows],
            // 서버에서 받은 첨부만 비고 수정 비교용 원본에 넣는다.
            originalHRM1030_R01FileList: [...state.originalHRM1030_R01FileList, ...rows.filter(row => !row.inserted)],
        };
    }),
    updateHRM1030_R01FileList: (valueIndex, value) => set(state => ({
        HRM1030_R01FileList: state.HRM1030_R01FileList.map(row =>
            row.valueIndex === valueIndex ? value : row),
    })),
    removeHRM1030_R01FileList: valueIndex => set(state => ({
        HRM1030_R01FileList: state.HRM1030_R01FileList.filter(row => row.valueIndex !== valueIndex),
    })),
    selectedHRM1030_R01FileList: [],
    setSelectedHRM1030_R01FileList: value => set({ selectedHRM1030_R01FileList: value.map(String) }),
    // 공통 useRowSelectionHandler가 숫자 valueIndex를 넘겨도 문자열로 저장한다. 작업지시처럼 누적하지 않고 교체한다.
    addSelectedHRM1030_R01FileList: ids => set({ selectedHRM1030_R01FileList: ids.map(String) }),
    removeSelectedHRM1030_R01FileList: ids => set(state => ({
        selectedHRM1030_R01FileList: ids
            ? state.selectedHRM1030_R01FileList.filter(id => !ids.map(String).includes(id))
            : [],
    })),
    deletedHRM1030_R01FileList: [],
    setDeletedHRM1030_R01FileList: value => set({ deletedHRM1030_R01FileList: value.map(String) }),
    originalHRM1030_R01FileList: [],
    loadedHRM1030_R01FileTrainingList: [],
    addLoadedHRM1030_R01FileTrainingList: value => set(state => ({
        loadedHRM1030_R01FileTrainingList: [...state.loadedHRM1030_R01FileTrainingList, String(value)],
    })),

    columnState: null,
    trainingColumnState: null,
    fileColumnState: null,
    setColumnState: value => set({ columnState: value }),
    setTrainingColumnState: value => set({ trainingColumnState: value }),
    setFileColumnState: value => set({ fileColumnState: value }),
    scrollTop: null,
    trainingScrollTop: null,
    fileScrollTop: null,
    setScrollTop: value => set({ scrollTop: value }),
    setTrainingScrollTop: value => set({ trainingScrollTop: value }),
    setFileScrollTop: value => set({ fileScrollTop: value }),
    allCount: 0,
    setAllCount: value => set({ allCount: value }),

    initData: () => set({
        HRM1030_R01Filter: { ...defaultHRM1030_R01Filter },
        HRM1030_R01PastFilter: { ...defaultHRM1030_R01Filter },
        activeGridType: 'training',
        HRM1030_R01List: [],
        selectedHRM1030_R01: undefined,
        HRM1030_R01TrainingList: [],
        originalHRM1030_R01TrainingList: [],
        ...emptyTrainingState,
        columnState: null,
        trainingColumnState: null,
        fileColumnState: null,
        scrollTop: null,
        trainingScrollTop: null,
        fileScrollTop: null,
        allCount: 0,
    }),
}));
